import * as React from 'react';
import { ProductReimbursableLogo } from '@grandvisionhq/lib-visuals';
import '../../../../context/actions.js';
import '../../../../context/reducer.js';
import { useProductData } from '../../../../context/product-context-hooks.js';
import '../../../../context/ProductContext.js';
import { useCmsData } from '../../../../context/CmsContext.js';
import '../../../../hooks/useCartDiscountsQuery/types.js';
import '@grandvisionhq/graphql';
import '@grandvisionhq/state';
import '../../../../operations/queries/get-accessories-by-slug.js';
import '../../../../operations/queries/get-contact-lens-by-slug.js';
import '../../../../operations/queries/get-frames-by-slug.js';
import '../../../../operations/queries/get-solutions-by-slug.js';
import '../../../../operations/queries/get-sunglasses-by-slug.js';
import '../../../../operations/queries/get-ready-reader-by-slug.js';
import '../../../../operations/queries/get-cart-discounts-by-promotion-identifier.js';
import '../../../../operations/queries/get-manufacturer-by-key.js';
import '@grandvisionhq/utils';
import '../../../../hooks/use-product-view-history.js';
import { useProductDetailQueryParams } from '../../../../hooks/use-product-detail-query-params.js';

const ProductReimbursableLogoContainer = ({ className  })=>{
    const { activeVariant  } = useProductData();
    const { isReimbursable  } = useProductDetailQueryParams();
    const { reimbursableLogos  } = useCmsData();
    if (!activeVariant.isInsuranceReimbursable) return null;
    return /*#__PURE__*/ React.createElement(ProductReimbursableLogo, {
        defaultLogo: reimbursableLogos === null || reimbursableLogos === void 0 ? void 0 : reimbursableLogos.default,
        alternativeLogo: reimbursableLogos === null || reimbursableLogos === void 0 ? void 0 : reimbursableLogos.alternative,
        variant: isReimbursable ? 'alternative' : 'default',
        className: className
    });
};

export { ProductReimbursableLogoContainer };
//# sourceMappingURL=ProductReimbursableLogoContainer.js.map
